/* eslint-disable max-len */
import React, { Fragment, useRef, useEffect, useState} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import {  useSelector } from 'react-redux';

const Table = ({pageNumber, handleOnClickSort,BranchDisabled,addOpen,confirmationState, sortValue, setConfirmationState,email, branchName, searchParams,openViewPopup,handleSidePopupClick,
    setOpenViewPopup}) => {
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const BranchList = useSelector(state => state.BranchSlice);
    const { List} = BranchList;
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');

    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    /**
     * The function handles sorting based on a given key and current sort value.
     */

    const handleSort = (key) => {
        // setLoading(true);
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }
    const handleSortIcons = (key) => {
        const val = searchParams.get('sort') || 'created_at+desc'
        const sortStatus = val && val.split('+')[0] === key && (val.endsWith('+desc')|| val.endsWith('+asc'));
        return sortStatus;
    };

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;

    return (
        <div className={`flex mb-1 overflow-auto scroll-bar ${List.data?.length > 7 ? "pb-[6px]" : "pb-135px"} px-1 mt-2.5`} id = "search-result">
            <table aria-label="Outside Table" className="w-full" id='admin-table'>
                <thead>
                    <tr>
                        <th class="w-[13%]">
                            <span class="flex text-start justify-start">Employee Number
                            </span>
                        </th>
                        <th class="w-[16%]">
                            <span class="flex text-start">Full Name
                            </span>
                        </th>
                        <th class="w-[15%]">
                            <span class="flex text-start">Email Address
                            </span>
                        </th>
                        <th class="w-[13%]">
                            <span class="flex items-start">Mobile Number
                            </span>
                        </th>
                        <th class="w-[11%]" id='created_at'>
                            <span class="flex items-start justify-start"  onClick={() => {handleSort('created_at')}}>Created on
                                <a href="#" class="pl-1.5 sortedIcon pt-2"><img loading="lazy" decoding="async" src={!handleSortIcons('created_at')?"/images/Vector.svg":branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg"} alt="icon"/></a>
                            </span>
                        </th>
                        <th class="w-[9%]" id='status'>
                            <span class="flex items-start justify-center" onClick={() => {handleSort('status')}}>Status
                                <a href="#" class="pl-1.5 sortedIcon pt-2"><img loading="lazy" decoding="async" src={!handleSortIcons('status')?"/images/Vector.svg":branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg"} alt="icon" /></a>
                            </span>
                        </th>
                        <th class="w-[7%]">
                            <span class="flex text-start justify-center">Actions
                            </span>
                        </th>
                    </tr>
                    <tr aria-colspan="7" class="h-1">
                    </tr>
                </thead>
                <tbody>
                    {List.data.map((item , index = 0) => (
                        <Fragment key={item._id}>
                            <TableBody
                                BranchDisabled={BranchDisabled}
                                branchName={branchName}
                                tableData={item}
                                setConfirmationState={setConfirmationState}
                                indexNum={index}
                                pageNumber={pageNumber}
                                selectedIndex={selectedIndex}
                                setSelectedIndex={setSelectedIndex}
                                selectedRef={selectedRef}
                                lastIndex={List.data?.length}
                                email={email}
                                openViewPopup={openViewPopup}
                                setOpenViewPopup={setOpenViewPopup}
                                handleSidePopupClick={handleSidePopupClick}
                            />
                        </Fragment>
                    ))}
                    
                </tbody>
                {List?.data?.length === 0 && (
                    <tbody>
                        <tr>
                            <td style={{ 'line-height': '100px' }} colspan="7" className="no-records-message">
                                {noSearchOrFilter ? `No Branch users added yet.` : 'No matching records found.'}
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
            
        </div>
    );
}

export default Table;
